import { IWrappedResult, getApiEndpoint, httpClient } from "@accurx/shared";

import { VaccineApprovalDetails } from "app/practices/Practices.types";
import { VaccinePracticeLinks } from "app/practices/vaccine/approvalRequests/ApprovalRequests.types";
import { VaccineDeliverySites } from "app/practices/vaccine/capacityDashboard/CapacityDashboard.type";

const ENDPOINTS = {
    vaccineApproval: "/api/recall/VaccineApprovalDetails",
    vaccineCapacity: "/api/recall/Practices/:practiceId/RecallVaccineCapacity",
    vaccineSiteLinks:
        "/api/recall/Practices/:practiceId/RecallVaccineSiteLinks",
    vaccineSiteUpdateApproval:
        "/api/recall/Practices/:practiceId/RecallVaccineSiteLinks/UpdateApproval",
    vaccineSiteLeaveDelivery:
        "/api/recall/Practices/:practiceId/RecallVaccineSiteLinks/LeaveDeliverySite",
} as const;

export const getVaccineDetails = (): Promise<
    IWrappedResult<VaccineApprovalDetails[]>
> =>
    httpClient.getReturnJsonSafeAsync(
        getApiEndpoint({
            path: ENDPOINTS.vaccineApproval,
        }),
    );

export const getVaccineCapacity = (
    practiceId: string,
): Promise<IWrappedResult<VaccineDeliverySites>> =>
    httpClient.getReturnJsonSafeAsync(
        getApiEndpoint({
            path: ENDPOINTS.vaccineCapacity,
            params: { practiceId },
        }),
    );

export const getVaccineSiteLinks = (
    practiceId: string,
): Promise<IWrappedResult<VaccinePracticeLinks>> =>
    httpClient.getReturnJsonSafeAsync(
        getApiEndpoint({
            path: ENDPOINTS.vaccineSiteLinks,
            params: { practiceId },
        }),
    );

export const postVaccineSiteLinksApproval = (
    practiceId: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: any,
): Promise<IWrappedResult<VaccinePracticeLinks>> =>
    httpClient.postJsonReturnJsonSafeAsync(
        getApiEndpoint({
            path: ENDPOINTS.vaccineSiteUpdateApproval,
            params: { practiceId },
        }),
        request,
    );
